// // "use client"

// // import { useState, useEffect } from "react"

// // const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api"

// // export const useApi = (endpoint) => {
// //   const [data, setData] = useState(null)
// //   const [loading, setLoading] = useState(true)
// //   const [error, setError] = useState(null)

// //   useEffect(() => {
// //     const fetchData = async () => {
// //       try {
// //         setLoading(true)
// //         const response = await fetch(`${API_BASE_URL}${endpoint}`)
// //         if (!response.ok) {
// //           throw new Error(`HTTP error! status: ${response.status}`)
// //         }
// //         const result = await response.json()
// //         setData(result)
// //       } catch (err) {
// //         setError(err.message)
// //       } finally {
// //         setLoading(false)
// //       }
// //     }

// //     fetchData()
// //   }, [endpoint])

// //   return { data, loading, error }
// // }

// // export const apiRequest = async (endpoint, options = {}) => {
// //   try {
// //     const response = await fetch(`${API_BASE_URL}${endpoint}`, {
// //       headers: {
// //         "Content-Type": "application/json",
// //         ...options.headers,
// //       },
// //       ...options,
// //     })

// //     if (!response.ok) {
// //       throw new Error(`HTTP error! status: ${response.status}`)
// //     }

// //     return await response.json()
// //   } catch (error) {
// //     console.error("API request failed:", error)
// //     throw error
// //   }
// // }

// "use client"

// import { useState, useEffect } from "react"

// const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api"

// export const useApi = (endpoint, dependencies = []) => {
//   const [data, setData] = useState(null)
//   const [loading, setLoading] = useState(true)
//   const [error, setError] = useState(null)

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true)
//         setError(null)

//         const response = await fetch(`${API_BASE_URL}${endpoint}`)

//         if (!response.ok) {
//           throw new Error(`HTTP error! status: ${response.status}`)
//         }

//         const result = await response.json()
//         setData(result)
//       } catch (err) {
//         setError(err.message)
//         console.error(`Error fetching ${endpoint}:`, err)
//       } finally {
//         setLoading(false)
//       }
//     }

//     fetchData()
//   }, dependencies)

//   return { data, loading, error }
// }

// export const apiRequest = async (endpoint, options = {}) => {
//   try {
//     const response = await fetch(`${API_BASE_URL}${endpoint}`, {
//       headers: {
//         "Content-Type": "application/json",
//         ...options.headers,
//       },
//       ...options,
//     })

//     if (!response.ok) {
//       throw new Error(`HTTP error! status: ${response.status}`)
//     }

//     return await response.json()
//   } catch (error) {
//     console.error(`API request failed for ${endpoint}:`, error)
//     throw error
//   }
// }

"use client"

import { useState, useEffect } from "react"

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api"

export const useApi = (endpoint, dependencies = []) => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true)
        setError(null)

        console.log(`Fetching from: ${API_BASE_URL}${endpoint}`)

        const response = await fetch(`${API_BASE_URL}${endpoint}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        })

        console.log(`Response status: ${response.status}`)

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        const result = await response.json()
        console.log(`API Response for ${endpoint}:`, result)

        // Extract data from the response structure
        setData(result.success ? result.data : result)
      } catch (err) {
        setError(err.message)
        console.error(`Error fetching ${endpoint}:`, err)
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [endpoint, ...dependencies])
  

  console.log("dddddddddddddddddddddddddddddddddddddddddddddddddddd",data,loading,error)

  return { data, loading, error }
}

export const apiRequest = async (endpoint, options = {}) => {
  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
      ...options,
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    return await response.json()
  } catch (error) {
    console.error(`API request failed for ${endpoint}:`, error)
    throw error
  }
}
